/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ol[_ngcontent-%COMP%]{margin:15px 0;padding:0}.breadcrumb[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000;text-decoration:none}.breadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline}.breadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]:before{content:\">\";margin:0 15px}"];
export { styles as styles };
